import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AccountSnackbars } from '../types/account-snackbars.config';

@Injectable({
  providedIn: 'root',
})
export class AccountSnackbarsService {
  private snackbar = inject(MatSnackBar);

  public successChangePassword(): void {
    this.snackbar.open(
      AccountSnackbars.successChangePassword.message,
      AccountSnackbars.successChangePassword.closeBtn,
      AccountSnackbars.successChangePassword.config
    );
  }

  public failChangePassword(): void {
    this.snackbar.open(
      AccountSnackbars.failChangePassword.message,
      AccountSnackbars.failChangePassword.closeBtn,
      AccountSnackbars.failChangePassword.config
    );
  }

  public successUpdateAccount(): void {
    this.snackbar.open(
      AccountSnackbars.successUpdateAccount.message,
      AccountSnackbars.successUpdateAccount.closeBtn,
      AccountSnackbars.successUpdateAccount.config
    );
  }

  public failureUpdateAccount(): void {
    this.snackbar.open(
      AccountSnackbars.failureUpdateAccount.message,
      AccountSnackbars.failureUpdateAccount.closeBtn,
      AccountSnackbars.failureUpdateAccount.config
    );
  }

  public successUpdateImage(): void {
    this.snackbar.open(
      AccountSnackbars.successUpdateImage.message,
      AccountSnackbars.successUpdateImage.closeBtn,
      AccountSnackbars.successUpdateImage.config
    );
  }

  public failureUpdateImage(): void {
    this.snackbar.open(
      AccountSnackbars.failureUpdateImage.message,
      AccountSnackbars.failureUpdateImage.closeBtn,
      AccountSnackbars.failureUpdateImage.config
    );
  }

  public exceededSizeImage(): void {
    this.snackbar.open(
      AccountSnackbars.exceededSizeImage.message,
      AccountSnackbars.exceededSizeImage.closeBtn,
      AccountSnackbars.exceededSizeImage.config
    );
  }

  public formatNotAllowed(): void {
    this.snackbar.open(
      AccountSnackbars.formatNotAllowed.message,
      AccountSnackbars.formatNotAllowed.closeBtn,
      AccountSnackbars.formatNotAllowed.config
    );
  }

  public failureSamePassword(): void {
    this.snackbar.open(
      AccountSnackbars.failureSamePassword.message,
      AccountSnackbars.failureSamePassword.closeBtn,
      AccountSnackbars.failureSamePassword.config
    );
  }
}
